export const carouselResize = () => {
    $('.carousel ').on('beforeChange', function(slick, currentSlide, nextSlide) {
        setTimeout(function() {
            $("img[usemap]").trigger("load");
        }, 50);
    });
};
